import * as Contract from '@tableau/api-external-contract-js';
import { TableauWorksheetEvent } from './TableauWorksheetEvent';

export class WorksheetFormattingChangedEvent extends TableauWorksheetEvent implements Contract.WorksheetFormattingChangedEvent {
  public constructor(worksheet: Contract.ExtensionWorksheet, private _formatting: Contract.WorksheetFormatting) {
    super(Contract.TableauEventType.WorksheetFormattingChanged, worksheet);
  }

  public get formatting(): Contract.WorksheetFormatting {
    return this._formatting;
  }
}
